<template>
  <div>
    <div class="zn-template-head">
      <span class="zn-template-title">{{title}}</span>
      <span class="zn-text-grey">{{subtitle}}</span>
    </div>
    <div class="zn-template-content" ref="tplContent">
      <div v-html="content" style="padding:15px;line-height:1.5;font-size:13px"></div>
    </div>
    <div class="zn-template-submit" @click="copy">一键复制</div>
  </div>
</template>
<script>
export default {
  props: {
    item: Object,
  },
  data() {
    return {
      titleMap: {
        BD邮件: { title: 'BD邮件模版', subtitle: '【】中的信息修改一下；就可以发邮件了' },
        BD电话: { title: 'BD电话话术', subtitle: '注意（） 中为自由发挥语句，非（） 的话术可以照着念' },
        推荐邮件: { title: '推荐人选邮件模版', subtitle: '【】中的信息修改一下；就可以发邮件了' },
        试单推荐邮件: { title: '试单推荐人选邮件模版', subtitle: '【】中的信息修改一下；就可以发邮件了' },
        独家委托: { title: '独家委托模版', subtitle: '【】中的信息修改一下；就可以发邮件了' },
        推荐确认: { title: '推荐确认模版', subtitle: '' },
        承诺书: { title: '承诺书模版', subtitle: '【】中的信息修改一下；就可以发邮件了' },
        离职辅导: { title: '离职辅导话术', subtitle: '培训如何做一个好的离职辅导' },
        辞职信: { title: '辞职信模版', subtitle: '培训如何写一份好的辞职信' },
        开票邮件: { title: '开票邮件模版', subtitle: '【】中的信息修改一下；就可以发邮件了' },
        催款邮件: { title: '催款邮件模版', subtitle: '【】中的信息修改一下；就可以发邮件了' },
        面试安排: { title: '面试安排模版', subtitle: '可以点击全文复制，或者手动复制想复制的内容' },
        面试反馈: { title: '面试反馈模版', subtitle: '可以点击全文复制，或者手动复制想复制的内容' },
        两年快速合伙人计划: { title: '两年快速合伙人计划', subtitle: '可以点击全文复制，或者手动复制想复制的内容' },
      },
      title: '',
      subtitle: '',
      content: '',
    }
  },
  watch: {
    item: function(newVal) {
      this.init()
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      if (this.titleMap[this.item.name]) {
        this.title = this.titleMap[this.item.name].title
        this.subtitle = this.titleMap[this.item.name].subtitle
      }
      this.content = this.item.hasStyle ? this.item.content : (this.item.content||'').replace(/ /g, '&nbsp;').replace(/\n/g, '<br>')
    },
    copy() {
      const oTextarea = document.createElement('textarea')
      oTextarea.value = this.content.replace(/&nbsp;/g, ' ').replace(/<br>/g, '\n').replace(/<[^>]+>/gim, '')
      document.body.appendChild(oTextarea)
      oTextarea.select()
      document.execCommand('Copy')
      document.body.removeChild(oTextarea)
      this.$message.success('复制成功')
    },
  }
}
</script>
